import React, { useState, useEffect } from "react";
import * as N from "./NoticiasStyle";
import SideBarBox from "../Sidebar/SideBarBox";
import { usePulse } from "../../context/LoadContext";
import { newsService } from "../../Services/newsService";
import { FaCalendarAlt, FaTimes } from "react-icons/fa";

// --- Componente de Mídia (Detecta Imagem ou Vídeo) ---
const MediaViewer = ({ url, title, isModal = false }) => {
  if (!url) return <N.MediaPlaceholder />;
  const isVideo =
    url.toLowerCase().endsWith(".mp4") || url.toLowerCase().endsWith(".webm");

  if (isVideo) {
    return (
      <N.CardVideo as="video" autoPlay loop muted playsInline isModal={isModal}>
        <source
          src={url}
          type={url.endsWith(".mp4") ? "video/mp4" : "video/webm"}
        />
        Seu navegador não suporta vídeos.
      </N.CardVideo>
    );
  }
  return <N.CardImage src={url} alt={title} isModal={isModal} />;
};

// --- Componente do Modal (COM A CORREÇÃO) ---
const NewsModal = ({ news, onClose, formatDate }) => {
  // A CHAVE DA CORREÇÃO ESTÁ AQUI
  // O hook useEffect foi movido para o topo do componente, ANTES do retorno condicional.
  // A chamada do hook é sempre executada, respeitando as Regras do React.
  useEffect(() => {
    // A lógica DENTRO do hook pode ser condicional.
    // Adicionamos o listener apenas se o modal estiver aberto (se 'news' existir).
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (news) {
      window.addEventListener("keydown", handleEsc);
    }

    // A função de limpeza remove o listener. Isso funciona corretamente
    // mesmo que o listener nunca tenha sido adicionado.
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [news, onClose]); // Adicionamos 'news' à dependência para o efeito reavaliar quando o modal abre/fecha.

  // O retorno condicional agora acontece DEPOIS dos hooks, o que é correto.
  if (!news) {
    return null;
  }

  return (
    <N.ModalOverlay onClick={onClose}>
      <N.ModalContent onClick={(e) => e.stopPropagation()}>
        <N.ModalCloseButton onClick={onClose}>
          <FaTimes />
        </N.ModalCloseButton>
        <MediaViewer url={news.mideaUrl} title={news.title} isModal={true} />
        <N.ModalTextContent>
          <N.NewsMeta>
            <FaCalendarAlt />
            <span>Publicado em {formatDate(news.dateCreated)}</span>
          </N.NewsMeta>
          <N.ModalTitle>{news.title}</N.ModalTitle>
          <N.ModalText>{news.text}</N.ModalText>
          {news.link && (
            <N.ModalFooter>
              <N.ReadMoreLink
                href={news.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver Fonte Original
              </N.ReadMoreLink>
            </N.ModalFooter>
          )}
        </N.ModalTextContent>
      </N.ModalContent>
    </N.ModalOverlay>
  );
};

// --- Componente Principal da Página (sem alterações) ---
export default function Noticias() {
  const [newsList, setNewsList] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null);
  const { showPulse, hidePulse } = usePulse();

  useEffect(() => {
    const loadNews = async () => {
      showPulse();
      try {
        const activeNews = await newsService.getActiveNews();
        setNewsList(activeNews);
      } catch (error) {
        console.error("Erro ao buscar notícias:", error);
      } finally {
        hidePulse();
      }
    };
    loadNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("pt-BR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <SideBarBox>
      <N.NewsContainer>
        <NewsModal
          news={selectedNews}
          onClose={() => setSelectedNews(null)}
          formatDate={formatDate}
        />
        <N.PageHeader>
          <N.PageTitle>Últimas Notícias</N.PageTitle>
          <N.PageSubtitle>
            Mantenha-se informado sobre as novidades da Golden Brasil.
          </N.PageSubtitle>
        </N.PageHeader>
        {newsList.length > 0 ? (
          <N.NewsGrid>
            {newsList.map((news) => (
              <N.NewsCard key={news.id} onClick={() => setSelectedNews(news)}>
                <MediaViewer url={news.mideaUrl} title={news.title} />
                <N.CardContent>
                  <N.NewsMeta>
                    <FaCalendarAlt />
                    <span>{formatDate(news.dateCreated)}</span>
                  </N.NewsMeta>
                  <N.CardTitle>{news.title}</N.CardTitle>
                </N.CardContent>
              </N.NewsCard>
            ))}
          </N.NewsGrid>
        ) : (
          <N.NoNewsMessage>
            Nenhuma notícia disponível no momento. Volte em breve!
          </N.NoNewsMessage>
        )}
      </N.NewsContainer>
    </SideBarBox>
  );
}
